export default {
	state: {
		token: localStorage.getItem('ius_access_token') || sessionStorage.getItem('ius_access_token') || null,
		account:
			JSON.parse(localStorage.getItem('ius_account_data')) ||
			JSON.parse(sessionStorage.getItem('ius_account_data')) ||
			null,
	},
	getters: {
		locale(state) {
			return state.account ? state.account.locale : 'it'
		},
		loggedAccount(state) {
			return state.account
		},
		loggedAccountId(state) {
			return state.account ? state.account.id : null
		},
		loggedAccountTable(state) {
			return state.account ? (state.account.model === 'IusPopuli\\Models\\User' ? 'users' : 'lawyers') : 'users'
		},
		loggedAccountType(state) {
			return state.account ? (state.account.model === 'IusPopuli\\Models\\User' ? 'user' : 'lawyer') : 'user'
		},
		loggedIn(state) {
			return state.token !== null
		},
		isUser(state) {
			return state.account ? state.account.model === 'IusPopuli\\Models\\User' : true
		},
		token(state) {
			return state.token
		},
	},
	mutations: {
		clearAccount(state) {
			state.account = null
		},
		clearToken(state) {
			state.token = null
		},
		setAccount(state, accountData) {
			state.account = accountData
		},
		setToken(state, token) {
			state.token = token
		},
	},
	actions: {
		clearAccount(context) {
			// Remove account data from storages and commit mutation
			localStorage.removeItem('ius_account_data')
			sessionStorage.removeItem('ius_account_data')
			context.commit('clearAccount')
		},
		clearToken(context) {
			// Set the authorization header to axios
			axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

			// Check if logged
			if (context.getters.loggedIn) {
				return new Promise((resolve, reject) => {
					axios
						.post('/logout', {
							id: context.getters.loggedAccount.id,
						})
						.then((response) => {
							// Remove token from storages and commit mutation
							localStorage.removeItem('ius_access_token')
							sessionStorage.removeItem('ius_access_token')
							context.commit('clearToken')

							resolve(response)
						})
						.catch((error) => {
							console.log(error)

							// Remove token from storages and commit mutation
							localStorage.removeItem('ius_access_token')
							sessionStorage.removeItem('ius_access_token')
							context.commit('clearToken')

							reject(error)
						})
				})
			}
		},
		retrieveAccount(context, data) {
			return new Promise((resolve, reject) => {
				// Set the authorization header to axios
				axios.defaults.headers.common.Authorization = 'Bearer ' + context.rootState.auth.token

				axios
					.get('/account')
					.then((response) => {
						// Read account data from response data
						const accountData = response.data.info

						if (data.remember) {
							// Store account data into local storage and commit mutation
							localStorage.setItem('ius_account_data', JSON.stringify(accountData))
							context.commit('setAccount', accountData)
						} else {
							// Store account data into session storage and commit mutation
							sessionStorage.setItem('ius_account_data', JSON.stringify(accountData))
							context.commit('setAccount', accountData)
						}

						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		retrieveToken(context, data) {
			return new Promise((resolve, reject) => {
				axios
					.post('/login', {
						username: data.username,
						password: data.password,
					})
					.then((response) => {
						// Read token from response data
						const token = response.data.info.auth.access_token

						if (data.remember) {
							// Store token into local storage and commit mutation
							localStorage.setItem('ius_access_token', token)
							context.commit('setToken', token)
						} else {
							// Store token into session storage and commit mutation
							sessionStorage.setItem('ius_access_token', token)
							context.commit('setToken', token)
						}

						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		sendMailConfirmChange(context, data) {
			return new Promise((resolve, reject) => {
				axios
					.get('/confirm/mail/' + data.key + '/' + data.token)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		sendMailConfirmLawyer(context, data) {
			return new Promise((resolve, reject) => {
				axios
					.get('/register/lawyer/confirm/' + data.token)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		sendMailConfirmUser(context, data) {
			return new Promise((resolve, reject) => {
				axios
					.get('/register/user/confirm/' + data.token)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		sendOptInLawyer(context, data) {
			return new Promise((resolve, reject) => {
				axios
					.get('/register/lawyer/resend/confirm/' + data.accountId)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		sendOptInUser(context, data) {
			return new Promise((resolve, reject) => {
				axios
					.get('/register/user/resend/confirm/' + data.accountId)
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		sendPasswordRecovery(context, data) {
			return new Promise((resolve, reject) => {
				axios
					.post('/password/recovery', {
						email: data.email,
					})
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		sendPasswordReset(context, data) {
			return new Promise((resolve, reject) => {
				axios
					.post('/password/reset', {
						password: data.password,
						password_confirmation: data.passwordConfirmation,
						token: data.token,
						key: data.key,
					})
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		sendRegisterLawyer(context, data) {
			return new Promise((resolve, reject) => {
				axios
					.post('/register/lawyer', {
						email: data.email,
						password: data.password,
						first_name: data.firstName,
						last_name: data.lastName,
						birth_date: data.birthDate,
						phone: data.phone,
						mobile: data.mobile,
						pec: data.pec,
						company_name: data.companyName,
						company_order_city: data.companyOrderCity,
						// company_order_date_registration: data.companyOrderDateRegistration,
						// company_members: data.companyMembers,
						// company_description: data.companyDescription,
						// company_specializations: data.companySpecializations,
						auth_newsletter: data.authNewsletter,
						auth_marketing: data.authMarketing,
						auth_marketing_partner: data.authMarketingPartner,
						auth_marketing_profiling: data.authMarketingProfiling,
						tax_as_public: data.taxAsPublic,
					})
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		sendRegisterUser(context, data) {
			return new Promise((resolve, reject) => {
				axios
					.post('/register/user', {
						email: data.email,
						password: data.password,
						first_name: data.firstName,
						last_name: data.lastName,
						birth_date: data.birthDate,
						phone: data.phone,
						mobile: data.mobile,
						// gender: data.gender,
						// occupation_id: data.occupationId,
						// occupation_details: data.occupationDetails,
						auth_newsletter: data.authNewsletter,
						auth_marketing: data.authMarketing,
						auth_marketing_partner: data.authMarketingPartner,
						auth_marketing_profiling: data.authMarketingProfiling,
						resume: data.resume,
					})
					.then((response) => {
						resolve(response)
					})
					.catch((error) => {
						console.log(error)
						reject(error)
					})
			})
		},
		updateAccount(context, data) {
			// Read account data from storages (local or session)
			const accountData = localStorage.getItem('ius_account_data')
				? JSON.parse(localStorage.getItem('ius_account_data'))
				: JSON.parse(sessionStorage.getItem('ius_account_data'))

			// Update provided account data
			if (data.firstName) {
				accountData.first_name = data.firstName
			}
			if (data.lastName) {
				accountData.last_name = data.lastName
			}
			if (data.email) {
				accountData.email = data.email
			}
			if (data.locale) {
				accountData.locale = data.locale
			}
			if (data.completed === 1) {
				accountData.completed = true
			} else if (data.completed === 0) {
				accountData.completed = false
			}
			if (data.main_address) {
				accountData.main_address = data.main_address
			}
			if (data.fiscal_data) {
				accountData.fiscal_data = data.fiscal_data
			}

			// Store account data into local storage and commit mutation
			localStorage.setItem('ius_account_data', JSON.stringify(accountData))
			context.commit('setAccount', accountData)
		},
	},
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js